import { useMemo } from "react";
import { IdentitySinglePicker, type IdentitySinglePickerConfig } from "./identitySinglePicker.tsx";
import type { CockpitUserCandidate } from "../../api/merchandiser.ts";

interface CockpitUserItem {
  id: number;
  name: string;
  email: string;
}

interface CockpitUserSinglePickerProps {
  users: CockpitUserCandidate[];
  value: number;
  onChange: (id: number) => void;
  disabled?: boolean;
}

/** Form field: pick one Cockpit user by ID, name, username or email. */
export function CockpitUserSinglePicker({ users, value, onChange, disabled }: CockpitUserSinglePickerProps) {
  const items = useMemo<CockpitUserItem[]>(
    () => users.map((u) => ({ id: u.userId, name: u.name || u.user, email: u.email ?? "" })),
    [users],
  );

  const config = useMemo<IdentitySinglePickerConfig<CockpitUserItem>>(
    () => ({
      items,
      getId: (u) => u.id,
      nameField: "name",
      noun: "Cockpit user",
      matchFn: (u, q) =>
        String(u.id).includes(q) ||
        u.name.toLowerCase().includes(q) ||
        u.email.toLowerCase().includes(q),
      secondaryFn: (u) => u.email,
    }),
    [items],
  );

  return <IdentitySinglePicker value={value} onChange={onChange} config={config} disabled={disabled} />;
}
